module.exports = __webpack_public_path__ + "img/login_bg.eac3911f.png";